import { Filter } from '@/interfaces/filter.interface'
import { APICarrier } from '@/models/api/carrier.model'
import { CarriersServices } from '@/services/modules/carriers.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class CarriersStore extends VuexModule {
    carriers: object[] = []
    carriersPaginate: object[] = []
    carrierForm: object|null = null

    @Mutation
    updateCarriers (newCarriers: object[]) {
        this.carriers = newCarriers
    }

    @Mutation
    updateCarriersPaginate (newCarriers: object[]) {
        this.carriersPaginate = newCarriers
    }

    @Mutation
    updateCarrier (newCarrier: object) {
        this.carrierForm = newCarrier
    }

    @Action
    getCarriers () {
        return new Promise((resolve) => {
            CarriersServices.getCarriers()
                .then(resp => {
                    store.commit('updateCarriers', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCarriersPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            CarriersServices.getCarriersPaginate(newParams)
                .then(resp => {
                    store.commit('updateCarriersPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCarriersById (id: number) {
        return new Promise((resolve) => {
            CarriersServices.getCarriersById(id)
                .then(resp => {
                    store.commit('updateCarrier', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editCarriers (params: APICarrier) {
        params = new APICarrier(params)

        return new Promise((resolve) => {
            if (!(params instanceof APICarrier)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CarriersServices.editCarriers(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createCarriers (params: APICarrier) {
        params = new APICarrier(params)

        return new Promise((resolve) => {
            if (!(params instanceof APICarrier)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CarriersServices.createCarriers(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteCarriers (id: number) {
        return new Promise((resolve) => {
            CarriersServices.deleteCarriers(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreCarriers (id: number) {
        return new Promise((resolve) => {
            CarriersServices.restoreCarriers(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
